<template>
    <div class="animated fadeIn">
        <div class="px-2">
            <b-row>
                <b-col sm="5" class="d-none d-md-block mb-3">
                    <h4 id="traffic" class="card-title mb-0">Bine ai venit!</h4>
                    <div class="text-muted">Iata sumarul comenzilor tale</div>
                </b-col>
            </b-row>
            <b-card>
                <div slot="header">
                    <i class="fa fa-users pl-1"></i> Comenzi agenti
                </div>
                <b-row>
                    <b-col cols="12" sm="6" lg="3">
                        <OrdersByStatusCount status="confirmed"></OrdersByStatusCount>
                    </b-col>

                    <b-col cols="12" sm="6" lg="3">
                        <OrdersByStatusCount status="inProgress"></OrdersByStatusCount>
                    </b-col>

                    <b-col cols="12" sm="6" lg="3">
                        <OrdersByStatusCount status="policy"></OrdersByStatusCount>
                    </b-col>

                    <b-col cols="12" sm="6" lg="3">
                        <OrdersByStatusCount status="canceled"></OrdersByStatusCount>
                    </b-col>
                </b-row><!--/.row-->
            </b-card>
            <b-card>
                <div slot="header">
                    <i class="fa fa-globe pl-1"></i> Comenzi online
                </div>

                <b-row>
                    <b-col cols="12" sm="6" lg="3">
                        <OrdersByStatusCount status="confirmed" :IsSiteOrder="true"></OrdersByStatusCount>
                    </b-col>

                    <b-col cols="12" sm="6" lg="3">
                        <OrdersByStatusCount status="inProgress" :IsSiteOrder="true"></OrdersByStatusCount>
                    </b-col>

                    <b-col cols="12" sm="6" lg="3">
                        <OrdersByStatusCount status="policy" :IsSiteOrder="true"></OrdersByStatusCount>
                    </b-col>

                    <b-col cols="12" sm="6" lg="3">
                        <OnlineErrorsCount  :IsSiteOrder="true"></OnlineErrorsCount>
                    </b-col>


                </b-row><!--/.row-->
            </b-card>
        </div>
    </div>
</template>

<script>
    import { Callout } from '@coreui/vue'
    import CalloutChartExample from './dashboard/CalloutChartExample'
    import OrdersByStatusCount from './Widgets/OrdersByStatusCount'
    import OnlineErrorsCount from './Widgets/OnlineErrorsCount'
    export default {
        name: 'dashboard',

        components: {
            Callout,
            CalloutChartExample,
            OrdersByStatusCount,
            OnlineErrorsCount

        }
    }
</script>
